module.exports = __webpack_public_path__ + "static/images/live-goods-icon2.44d8ffd.png";